export default __webpack_public_path__ + "static/media/aspa-group.79f46079.png";